var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _path17, _path18, _path19, _ellipse, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeelingProud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 669.68268,
    viewBox: "0 0 711.1879 669.68268",
    width: 711.1879,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m516.326 380.018v184.995l30.944 50.43 2.355 3.836h122.097l2.467-239.261z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m516.326 380.018v184.995l30.944 50.43 1.899-235.425z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m221.566 375.084v184.996l-30.944 50.43-2.355 3.835h-122.097l-2.467-239.261z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m221.566 375.084v184.996l-30.944 50.43-1.899-235.426z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m711.188 371.385v11.099h-663.518v-16.033l61.665-32.066h547.588z",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m711.188 371.385v11.099h-663.518v-16.033z",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m142.635 426.883h-29.6l-12.333-8.633h55.499z",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m142.635 462.649h-29.6l-12.333-8.633h55.499z",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m142.635 513.215h-29.6l-12.333-8.634h55.499z",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m142.635 563.78h-29.6l-12.333-8.633h55.499z",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m595.257 431.816h29.6l12.333-8.633h-55.499z",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m595.257 467.582h29.6l12.333-8.633h-55.499z",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m595.257 518.148h29.6l12.333-8.633h-55.499z",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m595.257 568.713h29.6l12.333-8.633h-55.499z",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m859.81989 235.61493h-249.18543a9.4227 9.4227 0 0 0 -9.42389 9.42389v167.85773a9.4227 9.4227 0 0 0 9.42389 9.42388h94.5929l-3.54389 22.62623s-20.25281 10.75927-6.01251 11.07574 81.32764 0 81.32764 0 12.97448 0-7.59479-11.39221l-3.33362-22.30976h93.7497a9.42266 9.42266 0 0 0 9.42388-9.42388v-167.85773a9.42266 9.42266 0 0 0 -9.42388-9.42389z",
    fill: "#3f3d56",
    transform: "translate(-244.40605 -115.15866)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m365.82336 130.42445h249.99557v139.87094h-249.99557z",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 490.82114,
    cy: 125.99415,
    fill: "#f2f2f2",
    r: 1.58225
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.82114,
    cy: 294.34559,
    fill: "#f2f2f2",
    r: 6.01255
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m481.452 357.952v3.165h-170.25v-2.532l.234-.633 4.196-11.392h162.339z",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m791.37558 470.01266c-.31011 1.3259-1.481 2.72467-4.1265 4.04741-9.4935 4.74675-28.797-1.2658-28.797-1.2658s-14.87315-2.53161-14.87315-9.17706a11.86592 11.86592 0 0 1 1.30377-.77528c3.99133-2.11163 17.2253-7.32222 40.69051.22062a9.78618 9.78618 0 0 1 4.46035 2.923 4.667 4.667 0 0 1 1.34202 4.02711z",
    fill: "#3f3d56",
    transform: "translate(-244.40605 -115.15866)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m791.37558 470.01266c-11.62 4.45247-21.97744 4.78472-32.607-2.59805a23.34328 23.34328 0 0 0 -13.88583-4.57268c3.99133-2.11163 17.2253-7.32222 40.69051.22062a9.78618 9.78618 0 0 1 4.46035 2.923 4.667 4.667 0 0 1 1.34197 4.02711z",
    opacity: 0.1,
    transform: "translate(-244.40605 -115.15866)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.40017,
    cy: 350.99016,
    fill: "#f2f2f2",
    rx: 4.11385,
    ry: 1.2658
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m481.452 357.952v3.165h-170.25v-2.532l.234-.633z",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m339.06751 115.15881a8.55394 8.55394 0 0 0 -4.96126 1.1083c-1.476 1.0108-2.40629 2.78162-3.35588 4.42947a52.98576 52.98576 0 0 1 -14.43428 16.30464c-4.28894 3.142-9.74169 7.05966-9.00789 12.85269a17.37163 17.37163 0 0 0 2.09058 5.4255c3.9566 7.987 14.75357 14.15926 13.69156 23.27309 3.931-6.58092-1.327-9.835 2.604-16.41586 1.87205-3.134 5.12412-6.67168 7.95054-4.70353.94637.659 1.56777 1.84095 2.55314 2.41917 2.35122 1.37972 4.85259-1.258 6.93387-3.12633 7.17685-6.44263 17.383-4.7548 26.31387-2.74743 4.21624.94767 8.8473 2.191 11.33971 6.2207 3.277 5.29821-3.11344 11.02034-4.72807 17.01049a3.264 3.264 0 0 0 3.50293 4.06214c2.67975-.26434 5.8542-.481 6.01278-1.65694 3.37154.12 7.50269-.26181 8.94728-3.7725a14.76216 14.76216 0 0 0 .69252-4.29319c.5302-5.89718 3.0331-11.27719 4.69119-16.88993s2.37906-12.1905-.41909-17.1668a19.86362 19.86362 0 0 0 -3.666-4.45557c-15.87901-15.36675-36.75642-17.90092-56.7515-17.87811z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m326.54375 190.06386s3.4534 28.7784-9.20909 31.08068 11.51136 41.4409 11.51136 41.4409l57.55681 6.90682-13.81364-46.04545s-9.20909-3.45341-3.4534-26.47613-42.59204-6.90682-42.59204-6.90682z",
    fill: "#ffb8b8",
    transform: "translate(-244.40605 -115.15866)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m47.028 569.318 4.605 63.313h24.173l-6.906-63.313z",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m224.303 449.6 3.453 52.952 26.477-11.511-10.361-43.743z",
    fill: "#ffb8b8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m274.16705 442.73826s1.15113 66.7659 8.058 88.63749 5.75568 23.02272 4.60455 26.47613-2.30228 1.15114-2.30228 6.90682-2.30227 96.69544 0 104.7534-6.90681 21.87159 0 23.02272 39.13863 0 40.28977-6.90682-9.20909-9.20909-4.60454-13.81363 11.51136-98.99772 11.51136-98.99772l16.11591-65.61476 29.92954-34.53409h63.31244l19.56932 75.975s-8.058 21.87159-2.30228 21.87159 40.28977 6.90682 40.28977-18.41818-11.51136-100.14886-13.81361-102.45113 1.15113-10.36023-2.30228-13.81364-43.74317-27.62727-58.70794-32.23181-35.95778-10.08487-35.95778-10.08487z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m498.63861 596.99051s-17.267-5.75568-25.325 11.51137-4.60454 21.87159-4.60454 21.87159 26.47613 9.20909 31.08068 4.60454c2.00333-2.00334 8.36471-2.69926 14.91273-2.84621 9.97289-.22381 12.62625-14.33323 3.20748-17.61885q-.42145-.147-.85317-.25539c-9.20909-2.30227-18.41818-17.26705-18.41818-17.26705z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.03826,
    cy: 59.36486,
    fill: "#ffb8b8",
    r: 34.53409
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m307.55 235.53374s56.40567 11.51136 70.21931-6.90682 19.56931 51.80113 19.56931 51.80113l6.90682 73.67272-10.36023 40.28977s-54.1034 43.74318-71.37044 47.19658-43.74318 5.75569-43.74318 5.75569 8.058-127.77613 8.058-130.0784 20.72041-81.73067 20.72041-81.73067z",
    fill: "#6c63ff",
    transform: "translate(-244.40605 -115.15866)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m324.70433 213.94456s-12.54979-7.18923-16.0032-.28241-35.68522 24.17385-39.13863 24.17385 6.90682 95.54431 2.30227 107.05567-26.47613 95.54433-13.81363 102.45114 3.45341-6.90682 16.11591 10.36022 74.82385 17.267 78.27726 10.36023-27.62727-58.708-21.87159-107.05567 14.96477-115.11362 6.90682-124.32271-12.77521-22.74032-12.77521-22.74032z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m366.258 221.7201 1.60341-5.518s47.89544 15.87824 50.19772 26.23847 1.15113 82.88181-6.90682 88.63749-19.56932 14.96477-11.51136 28.7784 17.267 28.77841 24.17386 29.92954 19.56931 9.20909 16.1159 17.267-44.89431-6.90682-44.89431-6.90682-27.62727-20.72045-26.47613-52.95227-2.30227-125.47381-2.30227-125.47381z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m406.54771 357.55418-27.62727 51.80113s-40.28976 41.4409-17.267 46.04545 35.68522-37.9875 35.68522-37.9875l29.92955-42.592z",
    fill: "#ffb8b8",
    transform: "translate(-244.40605 -115.15866)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m340.74981 124.19457a7.83806 7.83806 0 0 0 -4.03868.78334 9.41322 9.41322 0 0 0 -2.73182 3.13072 39.77267 39.77267 0 0 1 -11.7501 11.524c-3.49138 2.22077-7.93014 4.98972-7.3328 9.0842a11.35949 11.35949 0 0 0 1.70182 3.8347 30.16344 30.16344 0 0 1 3.66519 18.80068l9.60011-13.954c1.52393-2.21507 4.17125-4.7155 6.47207-3.32442.77039.46577 1.27623 1.30117 2.07836 1.70985 1.914.97518 3.95021-.88912 5.64447-2.20967 5.84225-4.55361 14.15049-3.36066 21.42059-1.94187 3.43219.66981 7.20207 1.54859 9.231 4.39676 3.37169 4.73311-.149 11.5721 1.81882 17.04a5.02339 5.02339 0 0 0 2.07852-3.31717c2.74457.08484 6.1075-.185 7.28345-2.66638a9.18757 9.18757 0 0 0 .56374-3.03439c.43161-4.16809 2.46907-7.97065 3.81883-11.93769s1.93666-8.61616-.34116-12.13338a14.68107 14.68107 0 0 0 -2.98426-3.14917c-12.92622-10.8611-29.92132-12.65223-46.19815-12.63611z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m406.54771 237.836 10.72528 2.84686s24.95995 63.919 19.20427 107.66222-9.20909 34.53409-9.20909 34.53409-9.20909-20.72046-29.92955-16.11591z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m293.02894 739.422c-2.77592 3.77228-2.21935 9.16459-4.67828 13.15075-2.13144 3.45526-6.14837 5.26695-8.81439 8.32869a22.32616 22.32616 0 0 0 -2.26617 3.25987c-2.47311 4.14255-4.4833 9.45174-2.04761 13.61641 1.95936 3.35022 6.07786 4.65961 9.855 5.552 4.77407 1.128 9.73436 2.03071 14.56354 1.16876s9.54882-3.819 11.27067-8.41239a32.50011 32.50011 0 0 1 1.2051-3.4007c2.61747-5.15294 10.82749-5.20864 13.50628-10.33 1.87466-3.584.15138-7.91623-1.57118-11.57578l-5.26109-11.1771c-1.74592-3.70919-8.82362-1.57608-12.51339-2.46492-4.81224-1.15915-9.78658-2.43633-13.24848 2.28441z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m254.59773 380.5769 48.34772 74.82386s29.92954 37.98749 39.13863 20.72045-32.23181-46.04545-32.23181-46.04545l-31.08068-57.55676z",
    fill: "#ffb8b8",
    transform: "translate(-244.40605 -115.15866)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m278.77159 240.13828-9.20909-2.30228s-18.41818 5.75568-23.02272 29.92954-1.15114 120.86931 4.60454 122.02044 28.42725-16.83663 32.05624-13.02286-7.88238-15.75554-4.429-26.11577.00003-110.50907.00003-110.50907z",
    fill: "#2f2e41",
    transform: "translate(-244.40605 -115.15866)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6c63ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m437.40692 176.36275h29.75235v7.1626h-29.75235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.72215 176.36275h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.65899 176.36275h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.62768 176.36275h71.07506v7.1626h-71.07506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.94099 222.6442h29.75235v7.1626h-29.75235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.25621 222.6442h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.19305 222.6442h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.16176 222.6442h71.07506v7.1626h-71.07506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.80718 192.34088h29.75235v7.1626h-29.75235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.02795 192.34088h29.75235v7.1626h-29.75235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.94099 192.34088h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.87784 192.34088h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.81466 192.34088h71.07506v7.1626h-71.07506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.09859 207.76802h29.75235v7.1626h-29.75235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.87783 207.76802h29.75235v7.1626h-29.75235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.941 207.76802h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m582.31189 207.76802h10.46842v7.1626h-10.46842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.76841 207.76802h71.07506v7.1626h-71.07506z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelingProud);
export default __webpack_public_path__ + "static/media/feeling-proud.681af8951a446d9147f16d66a9967ce9.svg";
export { ForwardRef as ReactComponent };